import type { ReactNode } from "react";
import { useEffect, useRef } from "react";
import { useToast } from "@chakra-ui/react";
import { useOnlineStatus } from "@/lib/pwa/useOnlineStatus";
import { useServiceWorkerUpdate } from "@/lib/pwa/useServiceWorkerUpdate";
import { UpdatePrompt } from "./UpdatePrompt";

export function PwaProvider({ children }: { children: ReactNode }) {
  const toast = useToast();
  const { isOnline, cameOnline } = useOnlineStatus();
  const { updateAvailable, applyUpdate } = useServiceWorkerUpdate();
  const offlineToastShown = useRef(false);

  useEffect(() => {
    if (!isOnline && !offlineToastShown.current) {
      offlineToastShown.current = true;
      toast({
        title: "Você está sem conexão",
        description: "Algumas funcionalidades estão indisponíveis.",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "top",
      });
    }

    if (isOnline) {
      offlineToastShown.current = false;
    }
  }, [isOnline, toast]);

  useEffect(() => {
    if (cameOnline) {
      toast({
        title: "Conexão restabelecida",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top",
      });
    }
  }, [cameOnline, toast]);

  return (
    <>
      {children}
      {updateAvailable ? <UpdatePrompt onUpdate={applyUpdate} /> : null}
    </>
  );
}
